import SettingConfig from '@module/config/setting';
import type { NormalChatMessage } from '@module/types/centrifuge/public-message/normalChatMessageTypes';
import type { FanLevel } from '@module/types/centrifuge/publicMessageTypes';
import type { HTMLProps } from 'react';

interface Props extends HTMLProps<HTMLImageElement> {
  type?: NormalChatMessage['data']['type'];
  level?: FanLevel;
  ranking?: number;
}

function ChatGradePrefixImage({ type, level, ranking, ...props }: Props) {
  if (type === 'bj')
    return (
      <img
        src={`${SettingConfig.S3_BUCKET_URL}/img/icon/grade/ico_class_bj.png`}
        alt='bj'
        {...props}
        className='mt-1 mr-1 h-[15px] w-[19px]'
        crossOrigin='anonymous'
      />
    );
  if (type === 'manager')
    return (
      <img
        src={`${SettingConfig.S3_BUCKET_URL}/img/icon/grade/ico_class_mj.png`}
        alt='manager'
        {...props}
        crossOrigin='anonymous'
      />
    );
  if (ranking === 1) {
    return (
      <img
        src={`${SettingConfig.S3_BUCKET_URL}/img/grade/fan_king.png`}
        alt='fan_king'
        {...props}
        crossOrigin='anonymous'
      />
    );
  }
  if (type === 'support') {
    return (
      <img
        src={`${SettingConfig.S3_BUCKET_URL}/img/icon/grade/class_supporter.png`}
        alt='support'
        {...props}
        crossOrigin='anonymous'
      />
    );
  }

  return (
    <>
      {(level === 0 || !level) && (
        <img
          src={`${SettingConfig.S3_BUCKET_URL}/img/icon/grade/ico_class_n.png`}
          alt='normal'
          {...props}
          crossOrigin='anonymous'
        />
      )}
      {level === 1 && (
        <img
          src={`${SettingConfig.S3_BUCKET_URL}/img/icon/grade/ico_class_b.png`}
          alt='bronz'
          {...props}
          crossOrigin='anonymous'
        />
      )}
      {level === 2 && (
        <img
          src={`${SettingConfig.S3_BUCKET_URL}/img/icon/grade/ico_class_s.png`}
          alt='silver'
          {...props}
          crossOrigin='anonymous'
        />
      )}
      {level === 3 && (
        <img
          src={`${SettingConfig.S3_BUCKET_URL}/img/icon/grade/ico_class_g.png`}
          alt='gold'
          {...props}
          crossOrigin='anonymous'
        />
      )}
      {level === 4 && (
        <img
          src={`${SettingConfig.S3_BUCKET_URL}/img/icon/grade/ico_class_d.png`}
          alt='dia'
          {...props}
          crossOrigin='anonymous'
        />
      )}
      {level === 5 && (
        <img
          src={`${SettingConfig.S3_BUCKET_URL}/img/icon/grade/ico_class_v.png`}
          alt='VIP'
          {...props}
          crossOrigin='anonymous'
        />
      )}
    </>
  );
}

export default ChatGradePrefixImage;
